module.exports = __webpack_public_path__ + "static/media/Faqs.a9c49626.svg";